import { render, staticRenderFns } from "./BjiOrderDeleteListTable.vue?vue&type=template&id=22422c37&scoped=true&lang=pug"
import script from "./BjiOrderDeleteListTable.vue?vue&type=script&lang=js"
export * from "./BjiOrderDeleteListTable.vue?vue&type=script&lang=js"
import style0 from "./BjiOrderDeleteListTable.vue?vue&type=style&index=0&id=22422c37&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22422c37",
  null
  
)

export default component.exports